
import React from 'react';
import { Link } from 'react-router-dom'

import ReactCardFlip from 'react-card-flip';
import { Box, Button, Typography,styled } from '@mui/material';
import Paragraphboxed from './Paragraphboxed';



const CustomTypography = styled(Typography) ({
  
  textAlign: 'start',
  lineHeight: '1',
  color: '#ffffff',
  fontSize: '1rem',
  '@media (max-width:400px)': {
    fontSize: '18px'
  }
  
})



class Cardflipone extends React.Component {
  constructor() {
    super();
    this.state = {
      isFlipped: false
    };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
    this.setState((prevState) => ({ isFlipped: !prevState.isFlipped }));
  }

  
  render() {
    return (
      <ReactCardFlip 
        isFlipped={this.state.isFlipped}
        flipDirection="horizontal"
        flipSpeedBackToFront={2}
        flipSpeedFrontToBack={2}
        height='fit-content'
      >
        <Box
          display="flex"
          padding='10px'
          flexWrap="wrap"
          verticalAlign="top"
          background='#000000'
          justifyContent="center"
          minWidth="300px"
          
          sx={{ maxWidth:'33vw',
            '@media (max-width:600px)': {
              minWidth: '100vw',
              maxwidth: '100vw',
            }
          }}
        >
          <img
            src="https://res.cloudinary.com/dpy1up1n6/image/upload/c_scale,w_1080,h_1080,dpr_auto,e_improve,f_auto,q_auto:good/v1680906029/egress-windows/escape-egress-window_gv4rbo_aetm8u.png"
            alt="escape egress window"
            width="95%"
            maxwidth='95vw'
          />

          <Box
          display="flex"
          padding='10px'
          flexWrap="wrap"
          verticalAlign="top"
          backgroundColor='rgba(0,0,0,0)'
          justifyContent="center"
          minWidth="200px"
          height='85%'
          position='absolute'
          width='85%'
          bottom='20px'
          sx={{maxwidth:'85%',
            '@media (max-width:600px)': {
              minWidth: '85%',
              maxwidth: '85%',
              color:'#ffffff'
            }
          }}>
           <CustomTypography
            sx={{color:'#ffffff'}}>
          <Paragraphboxed
            text="Escape Egress Window"
            fontFamily= {"'League Spartan', 'sans-serif'"}
            color='#fff'
            textAlign='center'
            maxwidth='85%'
            padding='10px'            
           
            sx={{
              position:'absolute',
              bottom:'100px',
              left:'40px'
            }}
            
           
          />
          </CustomTypography>
          </Box>
          <Button
            sx={{
              background: 'rgba(0,0,0,0.5)',
              borderRadius: '3px',
              border: 'none',
              color: '#eee',
              zIndex:'99999',
              position:'absolute',
              right:'40px',
              bottom:'20px'
            }}
            onClick={this.handleClick}
          >
            Flip
          </Button>
        </Box>

        <Box
          display="flex"
          padding='10px'
          flexWrap="wrap"
          verticalAlign="top"
          background='#000000'
          justifyContent="center"
          minWidth="300px"
          sx={{maxWidth:'33vw',
            '@media (max-width:600px)': {
              minWidth: '95vw',
              maxwidth: '95vw',
            }
          }}
        >

        <img
            src="https://res.cloudinary.com/dpy1up1n6/image/upload/c_scale,w_1080,h_1080,dpr_auto,e_improve,f_auto,q_auto:good/v1680906029/egress-windows/escape-egress-window_gv4rbo_aetm8u.png"
            alt="escape egress window"
            width="95%"
            opacity='0.2'
        />
          <Box
          display="flex"
          padding='10px'
          flexWrap="wrap"
          verticalAlign="top"
          backgroundColor='rgba(0,0,0,0.6)'
          justifyContent="center"
          minWidth="200px"
          height='85%'
          position='absolute'
          width='85%'
          bottom='20px'
          sx={{maxwidth:'85%',
            '@media (max-width:600px)': {
              minWidth: '85%',
              maxwidth: '85%',
              color:'#ffffff'
            }
          }}>
            <CustomTypography
            sx={{color:'#ffffff'}}>
          <Paragraphboxed
            text={
              'This is, by far, the most innovative, safe, and secure basement egress window.  It operates like a normal single hung window and also includes an inswing casement frame with a solid steel, durable 90% egress hinge.'
            }
            maxwidth="sm"
            mx={10}
           
            px={10}
            textAlign="left"
            color='#ffffff'
            padding="10px"
            verticalAlign="top"
            
            sx={{
            position: 'absolute',
            color: '#$ffffff',
            bottom: '100px',
            left: '20px',
            '@media (max-width:400px)': {
              fontSize: '18px'
            }
           }}
          />
          </CustomTypography>
          </Box>
          <Button sx={{
            background: 'rgba(0,0,0,0.5)',
            borderRadius: '3px',
            border: 'none',
            color: '#eee',
            zIndex:'99999',
            position:'absolute',
              right:'40px',
              bottom:'20px'
          }}
          
          
          onClick={this.handleClick}>Flip Back</Button>

          <Button
          component={Link} 
          to={'../egress-windows'}
          sx={{
            background: 'rgba(0,0,0,0.5)',
            borderRadius: '3px',
            border: 'none',
            color: '#eee',
            zIndex:'99999',
            position:'absolute',
              left:'40px',
              bottom:'20px'
          }}
          >

         Learn More</Button>
          
          
          
          </Box>
      </ReactCardFlip>
    );
  }
}

export default Cardflipone;


